// extracted by mini-css-extract-plugin
export default {"title":"pilih-kantor-marketing-penjual_title__JfUm1"};